import * as React from 'react';
import { Footer as FooterComponent, Header as HeaderComponent } from '../components/index';
import NavigationBar from '../components/DemoNavBar/DemoNavBar';
import { FacilityContext, LocationContext, LayoutContext } from '../components/context/index';
import { navBarTransformer, topBarTransformer } from '../transformers/navbarTransformer';

export const Footer = ({ facilityName, privacyPolicyLink, syrasoftLogoLink }: { facilityName: string, privacyPolicyLink: string, syrasoftLogoLink: string }) => {
    const facilityDetails = React.useContext<any>(FacilityContext)
    if (facilityName) {
        return <FooterComponent
            facilityName={facilityName}
            privacyPolicyLink={privacyPolicyLink}
            syrasoftLogoLink={syrasoftLogoLink}
        />
    }
    return <div>Loading...</div>
}


export const Header = ({ datoCmsData }: { datoCmsData: any }) => {
    const facilityDetails = React.useContext<any>(FacilityContext);
    const locationsData = React.useContext<any>(LocationContext);
    const layoutData = React.useContext<any>(LayoutContext);
    if (facilityDetails && locationsData && facilityDetails.datoCmsFacilityDetails) {
        if (facilityDetails.pageData && locationsData) {
            const navBarData = navBarTransformer(locationsData, layoutData.navbar[0].navLinks, facilityDetails.pageData);
            const headerData = topBarTransformer(locationsData[0], datoCmsData[0], facilityDetails);
            return (
                <div>
                    {locationsData.length <= 1 && <HeaderComponent {...headerData} />}
                    <NavigationBar
                        logo={facilityDetails.datoCmsFacilityDetails.facilityLogo?.url || ''}
                        facilityName={facilityDetails.datoCmsFacilityDetails.facilityName}
                        items={navBarData}
                    />
                </div>
            );
        }
    }
    return <div>Loading...</div>;
};
